import { createFileRoute } from "@tanstack/react-router"
import { FlaskConical } from "lucide-react"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/backoffice/conversationExperiments")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.conversationExperiments.header.title"),
      actions: (t) => [
        {
          id: "prompt-experiment",
          title: t("backoffice.conversationExperiments.promptExperiment.button"),
          icon: FlaskConical,
          variant: "testing",
          to: "/backoffice/conversationExperiments/list/prompt-experiment",
        },
      ],
    })
  },
})
